import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import LoginPanel from "@/components/dashboard/LoginPanel";
import SEO from "@/components/SEO";
import { usePrice } from "@/lib/price";

/**
 * /login — public entry point. Submits the email to /api/lead and shows
 * "check your inbox" on success. The real session cookie is set when the
 * user clicks the magic link from their inbox (handled by the backend).
 */
export default function Login() {
  const { price } = usePrice();
  return (
    <div
      data-testid="login-page"
      className="min-h-screen bg-[#FDFBF7] text-[#0a0a0a] bg-grid flex flex-col"
    >
      <SEO
        title="Log in / Sign up — JobHacki"
        description={`One-time email link. No password. Free account unlocks the free tools; ${price} unlocks every tool + the community.`}
        canonical="https://jobhacki.com/login"
      />
      <header className="border-b-4 border-[#0a0a0a] bg-[#FDFBF7]">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-[72px] flex items-center justify-between">
          <Link
            to="/"
            data-testid="login-back"
            className="inline-flex items-center gap-2 font-display text-xl md:text-2xl"
          >
            <img
              src="/jobhacki-logo.png"
              alt="JobHacki"
              className="h-9 w-9 border-2 border-[#0a0a0a] rounded-md object-cover"
            />
            JOBHACKI
          </Link>
          <Link
            to="/"
            className="hidden md:inline-flex items-center gap-2 font-accent text-sm hover:underline underline-offset-4 decoration-4 decoration-[#0055FF]"
          >
            <ArrowLeft size={14} strokeWidth={3} /> Back to home
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-5 py-16 md:py-24">
        <div className="w-full max-w-md">
          <LoginPanel source="login" />
        </div>
      </main>
    </div>
  );
}
